import { type CompletedLessons } from '@courses/types-layer/types/learner'

import { BaseService } from '@common/http-layer/service/base.service'
import { useLocation } from '@common/location-layer/composables/useLocation'

export class PostCompletionLearnerService extends BaseService {
  constructor() {
    super({
      baseURL: 'REST_API_URLS',
      basePath: '',
      headers: {
        version: '2021-07-28',
      },
    })
  }

  private endpoint(
    path: string = '',
    {
      courseId,
      locationId,
    }: {
      courseId: string
      locationId: string
    }
  ): string {
    const { store: state } = useLocation()
    if (!state.locationId) throw new Error('Location ID is required')
    return `/courses/learners/locations/${locationId ? locationId : state.locationId}/courses/${courseId}${path}`
  }

  async markPostAsCompleted(params: {
    courseId: string
    moduleId: string
    lessonId: string
    locationId: string
    payload: {
      productId: string
      postId: string
      percentage?: number
      userId?: string
      contactId?: string
    }
  }): Promise<any> {
    const { data } = await this.post(
      this.endpoint(`/modules/${params.moduleId}/lessons/${params.lessonId}/complete`, params),
      params.payload,
      {
        locationId: params.locationId,
        productId: params.courseId,
      }
    )
    return data
  }

  async markPostAsIncomplete(params: {
    courseId: string
    moduleId: string
    lessonId: string
    locationId: string
    completionRecordId: string
  }): Promise<any> {
    const { data } = await this.delete(
      this.endpoint(
        `/modules/${params.moduleId}/lessons/${params.lessonId}/completion/${params.completionRecordId}`,
        params
      ),
      {
        locationId: params.locationId,
        productId: params.courseId,
      }
    )
    return data
  }

  async getCompletedLessons(params: {
    courseId: string
    courseLocationId: string
  }): Promise<CompletedLessons> {
    const { data } = await this.get<CompletedLessons>(
      this.endpoint(`/lessons/completed`, {
        courseId: params.courseId,
        locationId: params.courseLocationId,
      }),
      {
        locationId: params.courseLocationId,
        productId: params.courseId,
      }
    )
    return data
  }
}
